import React from 'react';
import PropTypes from 'prop-types';
import suitcss from '../../../helpers/suitcss';
import { capitalize } from '../../../helpers/str';

import ContentGroupItem from './ContentGroupItem';

function ContentGroup(props) {
  const {
    theme,
    align,
    columns,
    items,
    moduleId,
    primaryModule,
    withBackgroundImage,
    adjacent,
    behaviorSettings,
  } = props;

  const modifiers = [
    align && `align${capitalize(align)}`,
    columns && `cols${columns}`,
    theme && `theme${capitalize(theme)}`,
    adjacent && 'adjacent',
  ];

  return (
    <div
      className={suitcss({
        componentName: 'ContentGroup',
        modifiers,
      })}
    >
      <div
        className={suitcss({
          componentName: 'ContentGroup',
          descendantName: 'inner',
        })}
      >
        {items.map((item, index) => (
          <ContentGroupItem
            primaryModule={primaryModule && !index}
            headline={item.headline}
            copy={item.copy}
            image={item.image}
            icon={item.icon}
            align={item.align}
            imageAlign={item.imagePosition}
            imageWidth={item.imageWidth}
            columns={columns}
            link={item.link}
            inverted={theme === 'dark'}
            moduleId={index === 0 ? moduleId : null}
            withTextShadows={withBackgroundImage}
            key={index}
            headlineLevel={behaviorSettings?.headlineLevel}
            focusOnMount={behaviorSettings?.focusOnMount}
            svgAriaHidden={behaviorSettings?.svgAriaHidden}
          />
        ))}
      </div>
    </div>
  );
}

ContentGroup.propTypes = {
  theme: PropTypes.oneOf(['', 'dark', 'light', 'secondary']),
  align: PropTypes.oneOf(['left', 'center', 'right']),
  columns: PropTypes.number,
  items: PropTypes.array,
  primaryModule: PropTypes.bool,
  moduleId: PropTypes.string,
  withBackgroundImage: PropTypes.bool,
  adjacent: PropTypes.bool,
  behaviorSettings: PropTypes.object,
};

ContentGroup.defaultProps = {};

export default ContentGroup;
